import { useState } from 'react';

import { ModalBase } from './ModalBase';

import type React from 'react';

export function ResolvePendencyModal({
  open,
  pendencyTitle,
  submitting,
  onClose,
  onConfirm,
}: {
  open: boolean;
  pendencyTitle: string;
  submitting: boolean;
  onClose: () => void;
  onConfirm: (p: { resolutionNote?: string }) => void;
}): React.JSX.Element | null {
  const [note, setNote] = useState('');
  if (!open) return null;
  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title="Resolver pendência"
      width={480}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button type="button" className="btn-ghost-mini" onClick={onClose}>
            Cancelar
          </button>
          <button
            type="button"
            className="btn-ghost-mini btn-ghost-mini--primary"
            disabled={submitting}
            onClick={() => onConfirm(note.trim().length > 0 ? { resolutionNote: note.trim() } : {})}
          >
            {submitting ? 'Resolvendo…' : 'Resolver'}
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <div className="modal-form__callout">{pendencyTitle}</div>
        <label className="modal-form__field">
          <span className="modal-form__label">Nota de resolução (opcional)</span>
          <textarea
            className="modal-form__textarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={3}
            placeholder="Ex.: equipamento substituído e cliente confirmou funcionamento."
          />
        </label>
      </div>
    </ModalBase>
  );
}
